import {
  type SingleQuestionCreationFormInput,
  getSingleQuestionSchema,
} from '../single-question-creation-form';

export const getSingleQuestionCreationEditSchema = getSingleQuestionSchema;

export type SingleQuestionCreationEditFormInput = SingleQuestionCreationFormInput;
